import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LabelCustomComponent = ({ component, data, form }) => {


    const isBlock = component.isBlock;
    const dataPath = component.dataPath;
    const [t, i18n] = useTranslation();
    const initialize = () => {

    };

    const getValueByPath = (dataPath, component) => {
        var componentData = component.includes("_") ? component.split("_")[0] : component;
        
        if (dataPath == "data")
            return componentData.split('.').reduce((acc, key) => acc && acc[key], data);

        if (dataPath == "form.settings.data")
            var splitPath = dataPath.split(".");
        splitPath.shift();
        let result = form._form;
        for (let i = 0; i < splitPath.length; i++) {
            result = result && result[splitPath[i]];
        }
        return componentData.split('.').reduce((acc, key) => acc && acc[key], result);
    };


    useEffect(() => {
        initialize();
    }, []);

    const parseCssToStyle = (cssString) => {
        if (!cssString) return {};
        return cssString
            .split(";")
            .map(rule => rule.trim())
            .filter(rule => rule !== "")
            .reduce((acc, rule) => {
                const [property, value] = rule.split(":").map(item => item.trim());
                if (property && value) {
                    acc[property] = value;
                }
                return acc;
            }, {});
    };
    return (

        <>
            <label
                style={{
                    ...parseCssToStyle(component.customCSS),
                    display: isBlock ? "block" : "inline",  margin: "5px"
                }}
            >
                {t(component.label)}
            </label>
            <span
                style={{
                    ...parseCssToStyle(""),
                    display: isBlock ? "block" : "inline",
                }}
            >
                {getValueByPath(dataPath, component.key) ?? ""}
            </span>
        </>



    );
};

export default LabelCustomComponent;